const DEBUG_ENABLED = process.env.NODE_ENV === 'development';

export const debug = (namespace) => {
  return (...args) => {
    if (DEBUG_ENABLED) {
      console.log(`[${namespace}]`, ...args);
    }
  };
}; 